<template>
  <v-dialog v-model="show" max-width="660px">
    <v-card class="pa-2">
      <v-card-title class="px-0 py-1">
        <v-spacer />
        <v-btn small icon @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-title class="justify-center pt-0">
        <span
          class="text-center font-weight-bold"
          style="color: #1a3e5c; font-size: 1.125rem; line-height: 1.4"
        >
          <span class="d-none d-md-inline text-no-wrap">
            Рекомендуйте PharmCenter — получайте дополнительный доход
          </span>
          <span class="d-md-none">
            Рекомендуйте PharmCenter<br />и получайте дополнительный доход
          </span>
        </span>
      </v-card-title>
      <div class="px-4">
        <v-img
          src="../../assets/img/RegionalPartnerBannerImage.png"
          class="rounded-lg"
          contain
        />
      </div>
      <v-card-text class="text-center pt-5">
        <p class="body-1" style="color: #333">
          Станьте региональным партнёром PharmCenter: рассказывайте коллегам о
          платформе и получайте вознаграждение за каждую подключённую аптеку.
        </p>
        <p class="body-2 grey--text mb-0">
          Мы предоставим обучение, готовые материалы и поддержку на всех этапах.
        </p>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-btn block large dark color="#16525A" @click="BecomePartner">
              Стать партнёром
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6">
            <v-btn block large outlined @click="show = false">
              Закрыть
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "RegionalPartnerBanner",
  data: () => ({
    show: false,
  }),
  methods: {
    BecomePartner() {
      window.open("https://partner.provisor.kz/", "_blank");
      this.show = false;
    },
  },
  mounted() {
    if (sessionStorage.getItem("showRegionalPartnerBanner")) {
      sessionStorage.removeItem("showRegionalPartnerBanner");
      this.show = true;
    }
  },
};
</script>
